import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SearchPage } from './search';

@NgModule({
  declarations: [
    SearchPage,
  ],
  imports: [
    IonicPageModule.forChild(SearchPage),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class SearchPageModule {}



// WEBPACK FOOTER //
// ./src/pages/search/search.module.ts